module.exports = __webpack_public_path__ + "static/visual_1_1_do-0c45acdf12b7ef5f351ace6cf3b6bd69.png";